import { Color } from '@nect/ui/theme/color';
import { propToBoxShadow, spacingPropToCSS } from '@nect/ui/theme/helper';
import styled from 'styled-components';

import { BorderRadius, Elevation, ShadowColor, SpacingProp } from '../../theme';
import { BoxAlignItems, BoxDirection } from '.';

interface IBoxStyledProps {
    $radius: BorderRadius;
    $borderSize: number;
    $borderColor: Color;
    $backgroundColor?: Color;
    $margin?: SpacingProp;
    $padding?: SpacingProp;
    $elevation?: Elevation;
    $shadowColor?: ShadowColor;
    $direction?: BoxDirection;
    $align?: BoxAlignItems;
}
const BoxStyled = styled.div<IBoxStyledProps>`
    border-radius: ${({ $radius, theme }) => theme.borderRadius[$radius]};
    border: ${({ $borderSize }) => ($borderSize ? `${$borderSize}px` : 0)} solid
        ${({ $borderColor, theme }) =>
            theme.color[$borderColor ?? Color.grey700]};

    ${({ $margin, theme }) =>
        $margin && spacingPropToCSS($margin, 'margin', theme)}
    ${({ $padding, theme }) =>
        $padding && spacingPropToCSS($padding, 'padding', theme)}

    ${({ $elevation, $shadowColor, theme }) =>
        $elevation && propToBoxShadow($elevation, $shadowColor, theme)}

    ${({ $backgroundColor, theme }) =>
        $backgroundColor &&
        `background-color: ${theme.color[$backgroundColor]};`}
    ${({ $direction }) => $direction && `flex-direction: ${$direction};`}
    ${({ $align }) => $align && `align-items: ${$align};`}
    display: flex;
    position: relative;
`;

// eslint-disable-next-line import/no-default-export
export default {
    BoxStyled,
};
